/**
 * Партнёрские куки (аналог PartnerCookie.vue) — без axios / tiny-cookie / PhpHelper.
 * Срабатывает при ?p=... без ?skp= (как isPartnerLink в Twig).
 */
(function initPartnerCookie() {
    const params = new URLSearchParams(window.location.search);
    if (!params.has('p') || params.has('skp')) {
        return;
    }

    const pid = params.get('p');
    const uri = window.location.pathname + window.location.search;
    const ref = document.referrer;
    const time = Math.floor(Date.now() / 1000);

    // PHP serialize только для {pid, time, uri, ref} — как PhpHelper.serialize
    function phpStr(value) {
        const str = String(value == null ? '' : value);
        let size = 0;
        for (let i = 0; i < str.length; i++) {
            const code = str.charCodeAt(i);
            size += code < 0x80 ? 1 : code < 0x800 ? 2 : 3;
        }
        return 's:' + size + ':"' + str + '"';
    }

    const cookieValue =
        'a:4:{' +
        phpStr('pid') + ';' + phpStr(pid) + ';' +
        phpStr('time') + ';i:' + time + ';' +
        phpStr('uri') + ';' + phpStr(uri) + ';' +
        phpStr('ref') + ';' + phpStr(ref) + ';' +
        '}';

    const expires = new Date();
    expires.setMonth(expires.getMonth() + 6);

    let cookie = 'partnrs=' + encodeURIComponent(cookieValue) +
        '; expires=' + expires.toUTCString() +
        '; path=/';
    const runtime = window.__APP_CONFIG__ || {};
    const domain = runtime.PUBLIC_DOMAIN_COOKIES || process.env.PUBLIC_DOMAIN_COOKIES;
    if (domain) {
        cookie += '; domain=' + domain;
    }
    document.cookie = cookie;

    const apiUrl = String(runtime.API_URL || process.env.API_URL || '').toLowerCase();
    if (apiUrl) {
        fetch(apiUrl + '/partners/add-stat-move', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': window.locale || 'ru',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
                partnerId: pid,
                uri: uri,
                ref: ref,
            }),
        }).catch(function () {});
    }

    function removePartnerFromUrl() {
        const url = new URL(document.location);
        url.searchParams.delete('p');
        history.pushState(null, null, url.toString());
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', removePartnerFromUrl);
    } else {
        removePartnerFromUrl();
    }
})();
